import { render } from "./BenefitsCalculatorLandingPage.vue?vue&type=template&id=1775f898&scoped=true"
import script from "./BenefitsCalculatorLandingPage.vue?vue&type=script&lang=js"
export * from "./BenefitsCalculatorLandingPage.vue?vue&type=script&lang=js"

import "./BenefitsCalculatorLandingPage.vue?vue&type=style&index=0&id=1775f898&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1775f898"]])

export default __exports__